export const USER_REGISTERED = 'user_registered';
export const USER_LOGIN = 'user_login';
export const USER_LOGOUT = 'user_logout';
export const USER_UPDATED = 'user_updated';
export const USER_LANGUAGE_UPDATED = 'user_language_updated';
export const USER_TIMEZONE_UPDATED = 'user_timezone_updated';
export const USER_PASSWORD_RESET = 'user_password_reset';
export const USER_PASSWORD_UPDATED = 'user_password_updated';
export const USER_PASSWORD_CREATED = 'user_password_created';
export const USER_EXTENSION_INSTALLED = 'user_extension_installed';
export const ACCOUNT_DELETE_REQUEST = 'account_delete_request';
export const USER_EMAIL_VERIFIED = 'user_email_verified';
export const USER_EMAIL_UNVERIFIED = 'user_email_unverified';
export const TEAM_UPDATED = 'team_updated';
export const TEAM_REPLY_BY_VIDEO_UPDATED = 'team_reply_by_video_updated';
export const TEAM_INVITE_CREATED = 'team_invite_created';
export const TEAM_INVITE_DELETED = 'team_invite_deleted';
export const TEAM_INVITE_RESENT = 'team_invite_resent';
export const TEAM_INCREMENT = 'team_increment';
export const TEAM_DECREMENT = 'team_decrement';
export const GREET_CREATED = 'greet_created';
export const GREET_BULK_CREATE = 'greet_bulk_create';
export const GREET_DELETED = 'greet_deleted';
export const GREET_BULK_DELETE = 'greet_bulk_delete';
export const GREET_ASSIGNED = 'greet_assigned';
export const GREET_CAMPAIGN_ASSIGNED = 'greet_campaign_assigned';
export const GREET_BULK_CAMPAIGN_ASSIGNED = 'greet_bulk_campaign_assigned';
export const GREET_COMPLETED = 'greet_completed';
export const GREET_BLOCKED = 'greet_blocked';
export const GREET_VIDEO_LIMIT_REACHED = 'greet_limit_reached';
export const GREET_VIDEO_LIMIT_WARNING = 'greet_limit_warning';
export const GREET_MESSAGE_OPENED = 'greet_message_opened';
export const GREET_VIDEO_EMBED_PLAYED = 'greet_video_embed_played';
export const GREET_WATCHED = 'greet_watched';
export const GREET_SHARED = 'greet_shared';
export const GREET_REACTION_THANK_YOU = 'greet_reaction_thank_you';
export const GREET_CTA_CLICKED = 'greet_cta_clicked';
export const GREET_RESEND = 'greet_resend';
export const GREET_WIDGET_CLOSED = 'greet_widget_closed';
export const GREET_SCHEDULER_LATER = 'greet_scheduler_later';
export const GREET_SCHEDULER_CHANGE_SCHEDULE = 'greet_scheduler_change_schedule';
export const GREET_SCHEDULER_SCHEDULE_DELETE = 'greet_scheduler_schedule_delete';
export const GREET_SCHEDULER_TIMEZONE = 'greet_scheduler_timezone';
export const GREET_SCHEDULER_TIME = 'greet_scheduler_time';
export const GREET_SCHEDULER_LATER_CANCEL = 'greet_scheduler_later_cancel';
export const GREET_SCHEDULER_LATER_CONFIRM = 'greet_scheduler_later_confirm';
export const GREET_UPLOAD_SUCCESS = 'greet_upload_success';
export const GREET_UPLOAD_ERROR = 'greet_upload_error';
export const GREET_ENCODING_ERROR = 'greet_encoding_error';
export const GREET_ENCODING_COMPLETED = 'greet_encoding_completed';
export const GREET_UPLOAD_VIDEO = 'greet_upload_video';
export const GREET_RECORD_NOW = 'greet_record_now';
export const GREET_RECORD_START = 'greet_record_start';
export const GREET_RECORD_STOP = 'greet_record_stop';
export const GREET_RECORD_SETTINGS = 'greet_record_settings';
export const GREET_RECORD_SETTINGS_CLOSE = 'greet_record_settings_close';
export const GREET_RECORD_REPLAY = 'greet_record_replay';
export const GREET_THUMBNAIL_SELECT = 'greet_thumbnail_select';
export const GREET_THUMBNAIL_CONFIRM = 'greet_thumbnail_confirm';
export const GREET_TEMPLATE_SELECT = 'greet_template_select';
export const GREET_CONFIRM_SEND = 'greet_confirm_send';
export const GREET_RECORD_DISCARD = 'greet_record_discard';
export const GREET_DISABLE_FALLBACK = 'greet_disable_fallback';
export const GREET_DISABLE_FALLBACK_CONFIRM = 'greet_disable_fallback_confirm';
export const TRANSMISSION_SENT = 'transmission_sent';
export const TRANSMISSION_ERROR = 'transmission_error';
export const AUTOMATION_CREATED = 'automation_created';
export const AUTOMATION_UPDATED = 'automation_updated';
export const AUTOMATION_DELETED = 'automation_deleted';
export const AUTOMATION_ACTIVATED = 'automation_activated';
export const AUTOMATION_DEACTIVATED = 'automation_deactivated';
export const AUTOMATION_FEEDBACK_PROVIDED = 'automation_feedback_provided';
export const AUTOMATION_FILTER_CREATE_NOW = 'automation_filter_create_now';
export const AUTOMATION_FILTER_SKIP = 'automation_filter_skip';
export const AUTOMATION_FILTER_DELETE = 'automation_filter_delete';
export const AUTOMATION_FALLBACK_CREATE_NOW = 'automation_fallback_create_now';
export const AUTOMATION_FALLBACK_SKIP = 'automation_fallback_skip';
export const AUTOMATION_FALLBACK_DELETE = 'automation_fallback_delete';
export const AUTOMATION_FALLBACK_DELETE_CONFIRM = 'automation_fallback_delete_confirm';
export const AUTOMATION_FALLBACK_RECORD_NOW = 'automation_fallback_record_now';
export const AUTOMATION_FALLBACK_RECORD_AGAIN = 'automation_fallback_record_again';
export const AUTOMATION_FALLBACK_CANCEL = 'automation_fallback_cancel';
export const AUTOMATION_AGREE_AND_SET_LIVE = 'automation_agree_and_set_live';
export const ADD_PAYMENT_METHOD_MODAL = 'add_payment_method_modal';
export const ONBOARDING_STARTED = 'onboarding_started';
export const ONBOARDING_SKIPPED = 'onboarding_skipped';
export const ONBOARDING_COMPLETED = 'onboarding_completed';
export const ONBOARDING_AUTOMATION_ADDED = 'onboarding_automation_added';
export const ONBOARDING_PAYMENT_ADDED = 'onboarding_paymen_added';
export const ONBOARDING_TASK_PERSONAL_VIDEO = 'onboarding_task_personal_video';
export const ONBOARDING_TASK_NON_PERSONAL_VIDEO = 'onboarding_task_non_personal_video';
export const ONBOARDING_AUTOMATION_AUTO_ADD = 'onboarding_automation_auto_add';
export const ONBOARDING_AUTOMATION_MANUAL_ADD = 'onboarding_automation_manual_add';
export const ONBOARDING_TASK_TESTIMONIAL = 'onboarding_task_testimonial';
export const AUTOMATION_CONTEXT_CREATED = 'automation_context_created';
export const AUTOMATION_CONTEXT_UPDATED = 'automation_context_updated';
export const AUTOMATION_GREET_CREATED = 'automation_greet_created';
export const ZAPIER_CONNECTED = 'zapier_connected';
export const ZAPIER_ACTIVATED = 'zapier_activated';
export const ZAPIER_GREET_CREATED = 'zapier_greet_created';
export const CHECKOUT_STARTED = 'checkout_started';
export const CHECKOUT_COMPLETED = 'checkout_completed';
export const NEW_CHECKOUT_COMPLETED = 'new_checkout_completed';
export const SUBSCRIPTION_CANCEL_VIEWED = 'subscription_cancel_viewed';
export const SUBSCRIPTION_CANCELLED = 'subscription_cancelled';
export const SUBSCRIPTION_PAUSED = 'subscription_paused';
export const SUBSCRIPTION_RESUMED = 'subscription_resumed';
export const SUBSCRIPTION_UPGRADED = 'subscription_upgraded';
export const SUBSCRIPTION_DOWNGRADED = 'subscription_downgraded';
export const SUBSCRIPTION_CHURNED = 'subscription_churned';
export const SUBSCRIPTION_UNPAID = 'subscription_unpaid';
export const SUBSCRIPTION_OVERDUE = 'subscription_overdue';
export const SUBSCRIPTION_TRIAL_ENDED = 'subscription_trial_ended';
export const SUBSCRIPTION_TRIAL_ENDING = 'subscription_trial_ending';
export const SUBSCRIPTION_SWITCHED_TO_FREE = 'subscription_switched_to_free';
export const MARKETING_CAMPAIGN_REDEEMED = 'marketing_campaign_redeemed';
export const COUPON_REDEEMED = 'coupon_redeemed';
export const CHARGE_FAILED = 'charge_failed';
export const CHARGE_SUCCEEDED = 'charge_succeeded';
export const UPGRADE_MODAL_VIEW = 'upgrade_modal_view';
export const UPGRADE_MODAL_SELECT_PLAN = 'upgrade_modal_select_plan';
export const VIEW_SETTINGS_BILLING = 'view_settings_billing';
export const BILLING_UPDATE_INFO = 'billing_update_info';
export const BILLING_UPDATE_INFO_SAVE = 'billing_update_info_save';
export const BILLING_UPDATE_CARD = 'billing_update_card';
export const BILLING_UPDATE_CARD_SUBMIT = 'billing_update_card_submit';
export const BILLING_INVOICE_DOWNLOAD = 'billing_invoice_download';
export const BILLING_SEE_ALL = 'billing_see_all';
export const BILLING_UPGRADE = 'billing_upgrade';
export const BILLING_SELECT_PLAN = 'billing_select_plan';
export const BILLING_MONTHLY_TOGGLE = 'billing_monthly_toggle';
export const BILLING_ANNUAL_TOGGLE = 'billing_annual_toggle';
export const BILLING_HAVE_COUPON = 'billing_have_coupon';
export const BILLING_REDEEM_COUPON = 'billing_redeem_coupon';
export const BILLING_CONFIRM_PAYMENT = 'billing_confirm_payment';
export const MESSAGE_TEMPLATE_CREATED = 'message_template_created';
export const MESSAGE_TEMPLATE_DELETED = 'message_template_deleted';
export const MESSAGE_TEMPLATE_RENAMED = 'message_template_renamed';
export const MESSAGE_TEMPLATE_LIMITED = 'message_template_limited';
export const MESSAGE_TEMPLATE_SAVED = 'message_template_saved';
export const MESSAGE_TEMPLATE_EMBEDS_UPDATED = 'message_template_embeds_updated';
export const USER_NOTIFICATIONS_UPDATED = 'user_notifications_updated';
export const UNSUBSCRIBE_FROM_NEWSLETTERS = 'unsubscribe_from_newsletters';
export const SENDER_SIGNATURE_CREATED = 'sender_signature_created';
export const SENDER_SIGNATURE_UPDATED = 'sender_signature_updated';
export const SENDER_SIGNATURE_VERIFIED = 'sender_signature_verified';
export const DOMAIN_CREATED = 'domain_created';
export const DOMAIN_VERIFIED = 'domain_verified';
export const DOMAIN_UNVERIFIED = 'domain_unverified';
export const DOMAIN_COMPLIANT = 'domain_compliant';
export const DOMAIN_DELETED = 'domain_deleted';
export const LANDING_DOMAIN_CREATED = 'landing_domain_created';
export const LANDING_DOMAIN_CHECK_RECORD = 'landing_domain_check_record';
export const LANDING_DOMAIN_VERIFIED = 'landing_domain_verified';
export const LANDING_DOMAIN_UNVERIFIED = 'landing_domain_unverified';
export const LANDING_DOMAIN_DELETED = 'landing_domain_deleted';
export const REDIRECT_HELP_CENTER = 'redirect_help_center';
export const REDIRECT_ROADMAP = 'redirect_roadmap';
export const REDIRECT_PRICING = 'redirect_pricing';
export const GUIDE_REDIRECT_TO_QUICK_START = 'guide_redirect_to_quick_start';
export const GUIDE_NAV_CLICK_QUICK_START = 'guide_nav_click_quick_start';
export const GUIDE_TIPS_CLICK_DISCOVER = 'guide_tips_click_discover';
export const GUIDE_TIPS_CLICK_FUNNELS = 'guide_tips_click_funnels';
export const GUIDE_TIPS_CLICK_CUSTOMER_STORIES = 'guide_tips_click_customer_stories';
export const GUIDE_TIPS_CLICK_COMMUNITY_LINK = 'guide_tips_click_community_link';
export const GUIDE_TIPS_CLICK_BOOK_DEMO = 'guide_tips_click_book_demo';
export const QSG_VM_VIEW = 'qsg_vm_view';
export const QSG_VM_VIEW_NEXT_STEP = 'qsg_vm_view_next_step';
export const QSG_TM_VIEW = 'qsg_tm_view';
export const QSG_TM_VIEW_NEXT_STEP = 'qsg_tm_view_next_step';
export const GUIDE_STEP_RECORD = 'guide_step_record';
export const GUIDE_STEP_PROFILE = 'guide_step_profile';
export const GUIDE_STEP_TEMPLATE = 'guide_step_template';
export const GUIDE_STEP_INTEGRATION = 'guide_step_integration';
export const GUIDE_STEP_DOMAIN_SETUP = 'guide_step_setup';
export const GUIDE_STEP_MORE_VIDEOS = 'guide_step_videos';
export const NOTIFICATION_SENT = 'notification_sent';
export const NOTIFICATION_CLICK = 'notification_click';
export const NOTIFICATION_OPEN = 'notification_open';
export const REPLY_CREATED = 'reply_created';
export const REPLY_RESPONDED = 'reply_responded';
export const REPLY_BY_VIDEO_UPLOADED = 'reply_by_video_uploaded';
export const REPLY_BY_VIDEO_COMPLETED = 'reply_by_video_completed';
export const REPLY_BY_VIDEO_STARTED = 'reply_by_video_started';
export const REPLY_BY_VIDEO_ENDED = 'reply_by_video_ended';
export const REPLY_BY_VIDEO_VIEWED = 'reply_by_video_viewed';
export const EXCEPTION_ENCOUNTERED = 'exception_created';
export const HELP_CLICKED = 'help_clicked';
export const HELP_CLICKED_CHAT = 'help_clicked_chat';
export const CAMPAIGN_CREATED = 'campaign_created';
export const CAMPAIGN_UPDATED = 'campaign_updated';
export const CAMPAIGN_DELETED = 'campaign_deleted';
export const CAMPAIGN_JOINED = 'campaign_joined';
export const RECORDING_STARTED = 'recording_started';
export const RECORDING_FINISHED = 'recording_finished';
export const RECORDING_DELETED = 'recording_deleted';
export const RECORDING_INTERACTION = 'recording_interaction';
export const RECORDING_RENAMED = 'recording_renamed';
export const RECORDING_MESSAGE_TEMPLATE_CHANGED = 'recording_message_template_changed';
export const RECORDING_EDIT_CLICKED_SHARE = 'recording_edit_clicked_share';
export const RECORDING_EDIT_COPY_EMAIL = 'recording_edit_copy_email';
export const RECORDING_EDIT_COPY_LINK = 'recording_edit_copy_link';
export const RECORDING_VIEWED = 'recording_viewed';
export const RECORDING_SHARE_MODAL_OPENED = 'recording_share_modal_opened';
export const RECORDING_WATCHED = 'recording_watched';
export const RECORDING_CTA_CLICKED = 'recording_cta_clicked';
export const VIDEO_LIBRARY_UPLOADED = 'video_library_uploaded';
export const VIDEO_LIBRARY_DELETED = 'video_library_deleted';
export const FEATURE_TOGGLE_CANARY_EXECUTED = 'feature_toggle_canary_executed';
export const FEATURE_TOGGLED = 'feature_toggled';
export const FEATURE_REMOVED = 'feature_removed';
export const MEDIA_ENCODING_ERROR = 'media_encoding_error';
export const NEXTGEN_TEMPLATE_ADD_VIDEO = 'nextgen_template_add_video';
export const NEXTGEN_TEMPLATE_ADD_EMBED = 'nextgen_template_add_embed';
export const VIDEO_RECORDING_EMBED_PLAYED = 'video_recording_embed_played';
export const VIEW_RESULTS_PAGE = 'view_results_page';
export const VIEW_RESULTS_TASK = 'view_results_task';
export const VIEW_RESULTS_WHY = 'view_results_why';
export const VIEW_RESULTS_SEND_NOW = 'view_results_send_now';
export const VIEW_RESULTS_CHANGE_SCHED = 'view_results_change_sched';
export const VIEW_RESULTS_CHANGE_SCHED_CONFIRM = 'view_results_change_sched_confirm';
export const CUSTOM_DOMAIN_LEARN_MORE = 'custom_domain_learn_more';
export const CUSTOM_DOMAIN_LEARN_MORE_GET = 'custom_domain_learn_more_get';
export const GET_CUSTOM_DOMAIN = 'get_custom_domain';
export const GET_CUSTOM_DOMAIN_CONTINUE = 'get_custom_domain_continue';
export const STRIPE_MODAL_PAYMENT_PAY = 'stripe_modal_payment_pay';
export const STRIPE_MODAL_PAYMENT_SUCCESS = 'stripe_modal_payment_success';
export const TESTIMONIAL_PROJECTS_VIEW = 'testimonial_projects_view';
export const TESTIMONIAL_RESPONSES_VIEW = 'testimonial_responses_view';
export const TESTIMONIAL_PROJECTS_INVITE = 'testimonial_projects_invite';
export const TESTIMONIAL_PROJECTS_CREATE = 'testimonial_projects_create';
export const TESTIMONIAL_PROJECTS_DELETE = 'testimonial_projects_delete';
export const TESTIMONIAL_PROJECTS_SAVE = 'testimonial_projects_save';
export const TESTIMONIAL_PROJECTS_PUBLISH = 'testimonial_projects_publish';
export const TESTIMONIAL_PROJECTS_EDIT = 'testimonial_projects_edit';
export const TESTIMONIAL_PROJECTS_INVITE_COPY = 'testimonial_projects_invite_copy';
export const TESTIMONIAL_PROJECT_SELECT = 'testimonial_project_select';
export const TESTIMONIAL_PROJECT_VIEW_RESPONSE = 'testimonial_project_view_response';
export const TESTIMONIAL_PROJECT_RESPONSE_DELETE = 'testimonial_project_response_delete';
export const TESTIMONIAL_PROJECT_RESPONSE_EMBED = 'testimonial_project_response_embed';
export const TESTIMONIAL_PROJECT_RESPONSE_VIDEOLINK = 'testimonial_project_response_videolink';
export const TESTIMONIAL_PROJECT_RESPONSE_DOWNLOAD = 'testimonial_project_response_download';
export const TESTIMONIAL_PROJECT_RESPONSE_COPY = 'testimonial_project_response_copy';
export const TESTIMONIAL_LANDING_VIEW = 'testimonial_landing_view';
export const TESTIMONIAL_LANDING_INTRO_LETS_GO = 'testimonial_landing_intro_letsgo';
export const TESTIMONIAL_RESPONSE_NEXT = 'testimonial_response_next';
export const TESTIMONIAL_RESPONSE_RECORD = 'testimonial_response_record';
export const TESTIMONIAL_RESPONSE_RECORD_START = 'testimonial_response_record_start';
export const TESTIMONIAL_RESPONSE_RECORD_STOP = 'testimonial_response_record_stop';
export const TESTIMONIAL_RESPONSE_RECORD_REPLAY = 'testimonial_response_record_replay';
export const TESTIMONIAL_RESPONSE_RECORD_DELETE = 'testimonial_response_record_delete';
export const TESTIMONIAL_RESPONSE_RECORD_REDO = 'testimonial_response_record_redo';
export const TESTIMONIAL_RESPONSE_RECORD_SETTINGS = 'testimonial_response_record_settings';
export const TESTIMONIAL_RESPONSE_RECORD_SETTINGS_SAVE = 'testimonial_response_record_settings_save';
export const TESTIMONIAL_RESPONSE_UPLOAD_SUCCESS = 'testimonial_response_upload_success';
export const TESTIMONIAL_RESPONSE_UPLOAD = 'testimonial_response_upload';
export const TESTIMONIAL_RESPONSE_TYPE = 'testimonial_response_type';
export const TESTIMONIAL_RESPONSE_FORM_CONSENT = 'testimonial_response_form_consent';
export const TESTIMONIAL_RESPONSE_FORM_NEXT = 'testimonial_response_form_next';
export const TESTIMONIAL_RESPONSE_SUBMIT = 'testimonial_response_submit';
export const TESTIMONIAL_RESPONSE_GET_STARTED = 'testimonial_response_get_started';
export const TESTIMONIAL_PUBLISH_VIEW = 'testimonial_publish_view';
export const TESTIMONIAL_PUBLISH_CREATE = 'testimonial_publish_create';
export const TESTIMONIAL_PUBLISH_TYPE = 'testimonial_publish_type';
export const TESTIMONIAL_PUBLISH_TESTIMONIAL_SOURCE = 'testimonial_publish_testimonial_source';
export const TESTIMONIAL_PUBLISH_SAVE = 'testimonial_publish_save';
export const TESTIMONIAL_PUBLISH_DELETE = 'testimonial_publish_delete';
export const TESTIMONIAL_PUBLISH_EMBED_CODE = 'testimonial_publish_embed_code';
export const TESTIMONIAL_PUBLISH_EMBED_COPY = 'testimonial_publish_embed_copy';
export const TESTIMONIAL_PUBLISH_RENAME = 'testimonial_publish_rename';
export const TESTIMONIAL_PUBLISH_DELETE_CONFIRM = 'testimonial_publish_delete_confirm';
export const TESTIMONIAL_PUBLISH_RENAME_CONFIRM = 'testimonial_publish_rename_confirm';
export const TESTIMONIAL_PUBLISH_PREVIEW = 'testimonial_publish_preview';
export const TESTIMONIAL_PUBLISH_TEMPLATE_SELECT = 'testimonial_publish_template_select';
export const TESTIMONIAL_PUBLISH_SELECT_CHANGE_SELECTION = 'testimonial_publish_select_change_selection';
export const TESTIMONIAL_PUBLISH_SELECT_CHANGE_ORDER = 'testimonial_publish_select_change_order';
export const TESTIMONIAL_PUBLISH_SELECT_TESTIMONIALS = 'testimonial_publish_select_testimonials';
export const TESTIMONIAL_PUBLISH_SELECT_TESTIMONIALS_SAVE = 'testimonial_publish_select_testimonials_save';
export const TESTIMONIAL_PUBLISH_SELECT_TESTIMONIALS_CANCEL = 'testimonial_publish_select_testimonials_cancel';
export const TESTIMONIAL_PUBLISH_SELECT_TESTIMONIALS_FILTER = 'testimonial_publish_select_testimonials_filter';
export const TESTIMONIAL_PUBLISH_DESIGN_COLOR = 'testimonial_publish_design_color';
export const TESTIMONIAL_PUBLISH_DESIGN_CORNER_ROUNDEDNESS = 'testimonial_publish_design_corner_roundedness';
export const TESTIMONIAL_PUBLISH_DESIGN_DROP_SHADOW_TOGGLE = 'testimonial_publish_design_drop_shadow_toggle';
export const TESTIMONIAL_PUBLISH_DESIGN_BORDER_TOGGLE = 'testimonial_publish_design_border_toggle';
export const TESTIMONIAL_PUBLISH_DESIGN_BORDER_PX = 'testimonial_publish_design_border_px';
export const TESTIMONIAL_PUBLISH_DESIGN_BORDER_COLOR = 'testimonial_publish_design_border_color';
export const TESTIMONIAL_PUBLISH_DESIGN_FONT = 'testimonial_publish_design_font';
export const TESTIMONIAL_PUBLISH_DESIGN_FONT_SELECT = 'testimonial_publish_design_font_select';
export const TESTIMONIAL_PUBLISH_SETTING_ENABLE_MAX_HEIGHT_TOGGLE = 'testimonial_publish_setting_enable_max_height_toggle';
export const TESTIMONIAL_PUBLISH_SETTING_USE_LOAD_MORE_BUTTON_TOGGLE = 'testimonial_publish_setting_use_load_more_button_toggle';
export const TESTIMONIAL_PUBLISH_SETTING_NUMBER_IN_ROW = 'testimonial_publish_setting_number_in_row';
export const TESTIMONIAL_PUBLISH_SETTING_AUTO_SLIDE_TOGGLE = 'testimonial_publish_setting_auto_slide_toggle';
export const TESTIMONIAL_PUBLISH_SETTING_BOX_HEIGHT_SAME_TOGGLE = 'testimonial_publish_setting_box_height_same_toggle';
export const TESTIMONIAL_PUBLISH_SETTING_BOX_HEIGHT_PX = 'testimonial_publish_setting_box_height_px';
export const TESTIMONIAL_PUBLISH_SETTING_LAYOUT_DISPLAY_NAME_TOGGLE = 'testimonial_publish_setting_layout_display_name_toggle';
export const TESTIMONIAL_PUBLISH_SETTING_LAYOUT_DISPLAY_TITLE_TOGGLE = 'testimonial_publish_setting_layout_display_title_toggle';
export const TESTIMONIAL_PUBLISH_SETTING_LAYOUT_DISPLAY_PROFILE_IMAGE_TOGGLE = 'testimonial_publish_setting_layout_display_profile_image_toggle';
export const TESTIMONIAL_PUBLISH_SETTING_LAYOUT_DISPLAY_DATE_TOGGLE = 'testimonial_publish_setting_layout_display_date_toggle';
export const TESTIMONIAL_PUBLISH_SETTING_LAYOUT_DISPLAY_PAGINATION_INDICATOR_TOGGLE = 'testimonial_publish_setting_layout_display_pagination_indicator_toggle';
export const TESTIMONIAL_PUBLISH_SETTING_LAYOUT_DISPLAY_CHEVRON_TOGGLE = 'testimonial_publish_setting_layout_display_chevron_toggle';
export const TESTIMONIAL_PUBLISH_SETTING_LAYOUT_REMOVE_BONJORO_TAG_TOGGLE = 'testimonial_publish_setting_layout_remove_bonjoro_tag_toggle';
export const TESTIMONIAL_LIBRARY_ALL_VIEW = 'testimonial_library_all_view';
export const TESTIMONIAL_LIBRARY_RESPONSES_VIEW = 'testimonial_library_responses_view';
export const TESTIMONIAL_LIBRARY_UPLOADS_VIEW = 'testimonial_library_uploads_view';
export const TESTIMONIAL_LIBRARY_ENTER_TEXT = 'testimonial_library_enter_text';
export const TESTIMONIAL_LIBRARY_TEXT_ADDED = 'testimonial_library_text_added';
export const TESTIMONIAL_LIBRARY_UPLOAD_VIDEO = 'testimonial_library_upload_video';
export const TESTIMONIAL_LIBRARY_UPLOADED = 'testimonial_library_uploaded';
export const TESTIMONIAL_LIBRARY_FILTER = 'testimonial_library_filter';
export const TESTIMONIAL_LIBRARY_SOCIAL_VIEW = 'testimonial_library_social_view';
export const TESTIMONIAL_LIBRARY_SOCIAL_ADD = 'testimonial_library_social_add';
export const TESTIMONIAL_LIBRARY_SOCIAL_ADD_FROM = 'testimonial_library_social_add_from';
export const TESTIMONIAL_LIBRARY_SOCIAL_UPLOADED = 'testimonial_library_social_uploaded';
export const TAG_CREATE = 'tag_create';
export const TAG_ADD = 'tag_add';
export const TAG_REMOVE = 'tag_remove';
export const TAG_DELETE = 'tag_delete';
export const TAG_EDIT_VIEW = 'tag_edit_view';
export const TAG_EDIT_SAVE = 'tag_edit_save';
export const WEB_DELIVERY_SETUP_VIEW = 'web_delivery_setup_view';
export const WEB_DELIVERY_TOGGLE = 'web_delivery_toggle';
export const WEB_DELIVERY_IDENTITY_TOGGLE = 'web_delivery_identity_toggle';
export const WEB_DELIVERY_MASTER_SCRIPT_COPY = 'web_delivery_master_script_copy';
export const WEB_DELIVERY_DISPLAY_UPDATE = 'web_delivery_display_update';
export const WEB_DELIVERY_CUSTOMIZE = 'web_delivery_customize';
export const WEB_DELIVERY_LIVE_CHAT_TOGGLE = 'web_delivery_live_chat_toggle';
export const WEB_DELIVERY_WIDGET_LOCATION = 'web_delivery_widget_location';
export const WEB_DELIVERY_WIDGET_BORDER_UPDATE = 'web_delivery_widget_border_update';
export const WEB_DELIVERY_WIDGET_SHOW_SETTINGS = 'web_delivery_widget_show_settings';
export const WEB_DELIVERY_WIDGET_PREVIEW = 'web_delivery_widget_preview';
export const WEB_DELIVERY_WIDGET_SAVE = 'web_delivery_widget_save';
export const WEB_DELIVERY_LEARN = 'web_delivery_learn';
export const SHARE_LIBRARY_ALL_VIEW = 'share_library_all_view';
export const SHARE_LIBRARY_RECORDINGS_VIEW = 'share_library_recordings_view';
export const SHARE_LIBRARY_UPLOADS_VIEW = 'share_library_uploads_view';
export const SHARE_LIBRARY_FILTER = 'share_library_filter';
export const SHARE_LIBRARY_UPLOAD_VIDEO = 'share_library_upload_video';
export const SHARE_LIBRARY_UPLOADED = 'share_library_uploaded';
export const VIDEO_EDIT_THUMBNAIL = 'video_edit_thumbnail';
export const VIDEO_EDIT_THUMBNAIL_SAVE = 'video_edit_thumbnail_save';
export const MY_LIBRARY_ALL_VIEW = 'my_library_all_view';
export const MY_LIBRARY_RECORDINGS_VIEW = 'my_library_recordings_view';
export const MY_LIBRARY_UPLOADED_VIEW = 'my_library_uploaded_view';
export const MY_LIBRARY_RESPONSES_VIEW = 'my_library_responses_view';
export const MY_LIBRARY_UPLOAD_VIDEO = 'my_library_upload_video';
export const MY_LIBRARY_UPLOADED = 'my_library_uploaded';
export const MY_LIBRARY_FILTER = 'my_library_filter';
export const ADD_CONTACT = 'add_contact';
export const EDIT_CONTACT = 'edit_contact';
export const REMOVE_CONTACT = 'remove_contact';
export const ADD_CONTACT_SEARCH = 'add_contact_search';
export const CREATE_CONTACT = 'create_contact';
export const CREATE_CONTACT_ADD_PROFILE_PHOTO = 'create_contact_add_profile_photo';
export const CREATE_CONTACT_ADD_COMPANY_LOGO = 'create_contact_add_company_logo';
export const ADD_CONTACT_CONFIRM = 'add_contact_confirm';
export const EDIT_CONTACT_SAVE = 'edit_contact_save';
export const SLIDER_PUBLISH_CREATE = 'slider_publish_create';
